import { FAQPageJsonLd } from "next-seo"
import { useMemo } from "react"
import { renderToStaticMarkup } from "react-dom/server"
import { getFaqData } from "./data"

export const JsonLdFaq = () => {
  const preparedFaq = useMemo(() => {
    const faqData = getFaqData({ forSchema: true })

    return faqData.map((faqItem) => ({
      questionName: faqItem.title,
      acceptedAnswerText: renderToStaticMarkup(faqItem.description),
    }))
  }, [])

  return <FAQPageJsonLd mainEntity={preparedFaq} />
}
